<template>
    <div>
        <page-title-bar title="BẢNG GIA HẠN INTERNET"></page-title-bar>
        <v-container grid-list-xl pt-0>
            <page-tool-bar show_search show_building :chosen_building.sync="chosen_building" :search.sync="search">
                <v-flex xs12 md2>
                    <v-menu :close-on-content-click="false" v-model="menu_renewal_date_filter" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width min-width="290px">
                        <v-text-field slot="activator" v-model="renewal_date_filter" label="Ngày gia hạn tiếp theo"
                            :disabled="loading || is_date_start_disabled" prepend-icon="event" readonly hide-details
                            clearable @click:clear="renewal_date_filter = ''"></v-text-field>
                        <v-date-picker type="month" :disabled="loading" locale="vi-VI" v-model="renewal_date_filter"
                            @input="menu_renewal_date_filter = false">
                        </v-date-picker>
                    </v-menu>
                </v-flex>
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="openRenewalDialog" color="primary" dark class="mr-2"
                            :disabled="!hasSelectedItems">GIA HẠN CÁC PHÒNG ĐÃ CHỌN</v-btn>
                        <v-btn @click="exportCSV++" color="primary" dark>XUẤT EXCEL</v-btn>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <internet-renewal-table :exportCSV="exportCSV" :chosen_building="chosen_building"
                            :search="search" :reload_table="reload_table" :renewal_date_filter="renewal_date_filter"
                            ref="renewalTable" @selection-changed="updateSelectedCount"></internet-renewal-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import InternetRenewalTable from './InternetRenewalTable';

export default {
    name: 'internet-renewal',
    components: {
        InternetRenewalTable
    },
    data() {
        return {
            search: '',
            reload_table: 0,
            chosen_building: '',
            exportCSV: 0,
            selectedItemsCount: 0,
            renewal_date_filter: '',
            menu_renewal_date_filter: false
        };
    },
    computed: {
        hasSelectedItems() {
            return this.selectedItemsCount > 0;
        }
    },
    mounted() {
        this.reload_table++
    },
    methods: {
        openRenewalDialog() {
            this.$refs.renewalTable.openRenewalDialog();
        },
        updateSelectedCount(count) {
            this.selectedItemsCount = count;
        }
    }
};
</script>
